import { Injectable } from '@angular/core';
import { PlanningTuningDal } from '@shared/dal/planningTuning.dal';
import { PlanningTuning } from '@shared/models/planningTuning.model';
import { PlanningTuningLogs } from '@shared/models/planningTuningLogs.model';
import { PlanningTuningStats } from '@shared/models/planningTuningStats.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlanningTuningService {
  constructor(private planningTuningDal: PlanningTuningDal) {}

  addPlanningTuningConfig(planningConfig: PlanningTuning): Observable<PlanningTuning> {
    return this.planningTuningDal.addPlanningTuningConfiguration(planningConfig);
  }

  updatePlanningTuningConfig(planningConfig: PlanningTuning): Observable<PlanningTuning> {
    return this.planningTuningDal.updatePlanningTuningConfiguration(planningConfig);
  }

  getPlanningConfigs(hospital: string, startDate: string, endDate: string): Observable<any> {
    return this.planningTuningDal.getPlanningConfigs(hospital, startDate, endDate);
  }

  validatePlanning(configId: string): Observable<any> {
    return this.planningTuningDal.validatePlanning(configId);
  }

  getPlanningTuningLogs(configId: string): Observable<PlanningTuningLogs[]> {
    return this.planningTuningDal.getPlanningTuningLogs(configId);
  }

  getPlanningTuningStats(configId: string): Observable<PlanningTuningStats> {
    return this.planningTuningDal.getPlanningTuningStats(configId);
  }

  getNeedsCoverage(configId: string): Observable<any> {
    return this.planningTuningDal.getNeedsCoverage(configId);
  }

  getPlanningTuning(configId: string): Observable<any> {
    return this.planningTuningDal.getPlanningTuning(configId);
  }
}
